































































































import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import GenericButton from '@/components/GenericButton.vue';
import {Prop, Vue, Watch} from 'vue-property-decorator';
import Component from 'vue-class-component';
import {Allocation, CommercialAccount, Organisation} from '@/types';
import {Getter} from 'vuex-class';

@Component({
  components: {CancelButton, ConfirmButton, GenericButton},
})
export default class SubscriptionOrderOrganisations extends Vue {
  @Getter private hasPermission: any;
  @Getter private activeAccountId: any;
  @Prop() private currentAccount!: CommercialAccount;
  @Prop() private accountOrganisations!: Organisation[];
  @Prop( { default: () => [] }) private accountAllocations!: Allocation[];
  @Prop() private allocationsToAdd!: Allocation[];
  private account: CommercialAccount | null = null;
  private allocations: Allocation[] = [];
  private newAllocations: any = [];
  private loading: boolean = false;

  @Watch('currentAccount', {immediate: true, deep: true})
  private onAccountChange() {
    this.account = {...this.currentAccount};
  }

  @Watch('accountAllocations', {immediate: true, deep: true})
  private onAllocationsChange() {
    this.allocations = this.accountAllocations;
  }

  @Watch('allocations', {immediate: true, deep: true})
  @Watch('allocationsToAdd', {immediate: true, deep: true})
  private onAllocationCountChange(allocations: Allocation[]) {
    for (const org of allocations) {
      if (org.allocatedSubscriptions !== null && org.allocatedSubscriptions !== undefined && org.allocatedSubscriptions <= 0) {
        this.$nextTick(() => {
          this.$emit('validateAllocations');
        });
      }
    }
  }

  private addOrgAccess() {
    this.newAllocations.push({ organisationId: 0, organisationName: '', allocatedSubscriptions: 1 });
  }

  private removeNewAllocation(org: Allocation) {
    this.$emit('addAllocation', this.allocationsToAdd.filter((o: Allocation) => o.organisationId !== org.organisationId));
  }

  private async removeOrganisationAllocation(org: Allocation) {
    const orgs = this.accountOrganisations && this.accountOrganisations.length ? this.accountOrganisations : this.account && this.account.organisations && this.account.organisations.length ? this.account.organisations : [];
    if (this.account && orgs) {
      this.$emit('keepAllocation', this.accountOrganisations.filter((o: Organisation) => o.id !== org.organisationId) || []);
      this.$emit('removeAllocation', this.allocations.filter((o: Allocation) => o.organisationId !== org.organisationId) || []);
    }
  }

  private async addAllocation(org: Organisation) {
    if (this.allocations) {
      const allocationsToAdd = this.allocationsToAdd || [];
      allocationsToAdd.push({ organisationId: org.id, organisationName: org.name, allocatedSubscriptions: 1 });
      this.$emit('addAllocation', allocationsToAdd);
      this.newAllocations = [];
    }
  }

  private addAllOrgs() {
    const orgs = this.accountOrganisations && this.accountOrganisations.length ? this.accountOrganisations : this.account && this.account.organisations && this.account.organisations.length ? this.account.organisations : [];
    if (this.account && orgs) {
      const existingOrgIds = new Set(this.allocations.map((a: Allocation) => a.organisationId));
      this.newAllocations = [];
      this.$emit('addAllocation', this.accountOrganisations
          .filter((o) => !existingOrgIds.has(o.id))
          .map((o) => ({
            organisationName: o.name,
            organisationId: o.id,
            allocatedSubscriptions: 1,
          })));
    }
  }

  private removeAllOrgs() {
    this.allocations = [];
    this.newAllocations = [];
    this.$emit('addAllocation', []);
    this.$emit('removeAllocation', []);
  }

  private get filteredOrganisations() {
    if (!this.account) { return []; }
    const orgs = this.accountOrganisations && this.accountOrganisations.length ? this.accountOrganisations : this.account.organisations && this.account.organisations.length ? this.account.organisations : [];
    if (!orgs.length) {
      return [];
    } else {
      return orgs.filter((org: Organisation) => {
        const addingOrg = this.allocationsToAdd.map((a: Allocation) => a.organisationId).includes(org.id);
        const hasOrg = this.allocations.map((a: Allocation) => a.organisationId).includes(org.id) || false;

        return !addingOrg && !hasOrg;
      });
    }
  }
}
